import { sendAuthorizedRequest } from './jwtApi'
import { BASE_URL } from 'api/config'
import {
  ApiResponse,
  ReservationHistory,
} from 'types'

export async function getReservationHistory(): Promise<ApiResponse<Array<ReservationHistory>>> {
  let reservations_endpoint_url = BASE_URL + 'booking/reservation_history/'

  let result = await sendAuthorizedRequest(reservations_endpoint_url)

  return {
    status_code: result.status,
    ok: result.ok,
    body: await result.json(),
  }
}
